module.exports = __webpack_public_path__ + "img/QUITTING BEFORE POSTING-th.e2b91b5.png";